module.exports = __webpack_public_path__ + "img/ecology.e4a5b0b1.svg";